export const AutoFinancingShow = 'FinancingApplyNow'
export const AutoFinancingBegin = 'R2SFinancingBegin'
export const AutoFinancingAttempt = 'R2SFinancingAttempt'
export const AutoFinancingSuccess = 'R2SFinancingSuccess'
export const AutoFinancingFail = 'R2SFinancingFail'
